import dayjs from 'dayjs'
import i18n from '@/i18n'

export function getTirOptions(data, myChart) {
  return {
    title: {
      show: false
    },
    animation: false,
    series: [
      {
        type: 'pie',
        radius: [20, 60],
        left: 'center',
        width: 350,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
          color: ({ seriesIndex, dataIndex, data, value }) => {
            return ['#F59A24', '#FFFD01', '#0E9A33', '#E56363', '#CC5858'][data.index]
          }
        },
        label: {
          alignTo: 'edge',
          // formatter: `{name|{b}}\n{time|{c} ${i18n.tc('unit.hours')}}`,
          formatter: (parmas) => {
            return `{name|${parmas.name}}\n{time|${parmas.data.timeStr} ${i18n.tc('unit.hours')}}`
          },
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          fontSize: 11,
          overflow: 'none',
          rich: {
            time: {
              fontSize: 10,
              color: '#999'
            }
          }
        },
        labelLine: {
          length: 5,
          length2: 0,
          maxSurfaceAngle: 80
        },
        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2
          const points = params.labelLinePoints
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width
          return {
            labelLinePoints: points
          }
        },
        data: data
      }
    ]
  }
}

export function getAgpOptions(
  data_10 = [],
  data_25 = [],
  data_50 = [],
  data_75 = [],
  data_90 = [],
  isMgDl = false,
  hyper = 10,
  hypo = 3.9,
  isToB = true
) {
  const intervalTime = data_10.length === 1440 ? 1 : 5
  const marklineObj = {
    symbol: 'none',
    data: [
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#ffaf00',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.high')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
      },
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#d4001a',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.low')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
      }
    ]
  }

  return {
    tooltip: {
      show: false,
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 30,
      x2: isToB ? 100 : 20,
      y2: 30
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        axisLine: {
          show: true
        },
        type: 'value',
        position: isToB ? 'right' : 'left',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? 16 : 'auto',
      left: isToB ? 'auto' : -4,
      top: 9
    },
    animation: false,
    series: [
      {
        z: -1,
        name: '10%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        markLine: marklineObj,
        areaStyle: {
          opacity: 1,
          color: 'white'
        },
        data: data_10.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -2,
        name: '25%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_25.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -3,
        name: '50%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 2,
          color: '#05367f'
        },
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        showSymbol: false,
        // markLine: marklineObj,
        data: data_50.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -5,
        name: '75%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        // markLine: marklineObj,
        data: data_75.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -6,
        name: '90%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        label: {
          show: true,
          position: 'top'
        },
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_90.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      }
    ]
  }
}

export function getGluOptions(
  data = [],
  index,
  date,
  event = [],
  isMgDl = false,
  hyper = 10,
  hypo = 3.9,
  isToB = true
) {
  const intervalTime = data.length === 1440 ? 1 : 5
  const dayStr = dayjs(date)
    .add(index, 'day')
    .startOf('day')
    .format('YYYY-MM-DD')
  event = event[dayStr] || []
  // event = event.slice(0, 10)
  let memIndex = []
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs(date).add(index, 'day').startOf('day'),
        max: +dayjs(date)
          .add(index + 1, 'day')
          .startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        position: isToB ? 'right' : 'left',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true
        },
        // name: "mmol/L",
        // nameLocation: "middle",
        // nameGap: 30,
        // nameTextStyle: {
        //   fontWight: "bold",
        // },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? 16 : 'auto',
      left: isToB ? 'auto' : -4,
      top: -11
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 10,
      x2: isToB ? 100 : 20,
      y2: 30
    },
    animation: false,
    series: [
      {
        name: '血糖值',
        type: 'line',
        data: data.map((c, i) => [
          +dayjs(date)
            .add(index, 'day')
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markPoint: {
          symbolSize: 20,
          symbolKeepAspect: true,
          symbolOffset: [0, -10],
          itemStyle: {
            borderWidth: 0
            // color: "red",
          },
          data: event.map((item, eventIndex) => {
            const eventType = item.eventType
            let symbol = 'pin'
            const color = '#000'
            if (eventType === 1) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#c74e4e";
            } else if (eventType === 2) {
              symbol =
                'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAA81BMVEUAAABFi/9KlP9Ei/9Fi/9Fi/9JkP9Ei/9Ei/9Ei/9Fi/9Fi/9FjP9Gjf9Ylv9Fi/9Ei/9Ei/9Fiv9FjP9Ei/9Hi/9IjP9mmf9FjP9Eiv9Eiv9Fi/9Eiv9Ei/9Fi/9Fi/9Gi/9Eiv9FjP9Fi/9Ei/9EjP9Ei/9Jjf9Hjf9Eiv/////8/f/q8v9Pkf9mn//i7f/1+f+Ar//X5v9Jjf+gxP/v9f9cmf+Gs/9UlP9Mj//n8P/b6f+Wvf/I3f+20v9hnP/y9//S4//A2P+wzv9Zl//5+/+Ruv92qf+bwP9vpf/N4P9rov+71P+ryv+mx/+Mt/97rP8jvEBHAAAAKXRSTlMA/hDv2p8V+OfixXJjQQl86rKZiWs4HgV+0s3Mwru5qY90XVxWUksxL0KzY0AAAAkeSURBVHja1NrZVhpBEAbg7hn2TUBxSdyj0b/YBVEEZVXcQvL+T5OQhKMM0zBjdw/jd80Np+rvKjjF9DDOTuPrwUwsEE2bYc7DZjoaiGWC6/HTM4N9DqFkPPjVxALm12A8GWJ+tnkcjMKhaPB4k/lR6CQbgEuB7InPKpM73OH4EL5zmGM+sbkdgJTAtg+azEjsckjjuwmDrdL3gzAUCR98ZyuylQhAqUBii3kvtRGFctGNFPNW6igCLSJHXn4VY82ENuaaZ7nfMKGVucG8kPsC7b7oH5JGlsMDPKu5vxJpeCSdYPqcx+Ch2DnTZI3DU3yN6RDah+f2Q0y5ZAQrEEl+9rbS1F6hPazMXuizt5X69voWxkqFvzEl4hwrxuNMgXX4wDqTtRWELwS3mJRUBj6RSTEJRgy+ETMkvscOfGTH+HBf+ageE7HUB3Pum3xMZT6WeJ+8V+8FP+38UDBP4vCluOv9auV7iT3ucu9KhuFT4SRzIRSBb0VCzLk9+Ngec2wNvrbmOCAcnilWX1uX94WLH09wjCd9F5BmvUJT5SqccRyTfXjlpUDv3Rbh0L6/AnJ1T7PKDTjiKCbnHB55ypNVuQln+DlbJgaPDLs0rw+HYmyJBLxyR3ZGcCjBFjLS8EgnT3Yu4FDaYItk4ZU62evAoSxbIMfhlRbZe4RDPMfEvsArNRLow6kvTGgDnmmQwAUc2xAm3YRnXkigDMdMUd63Ic3TimCb2UqZkCedkVs4Z6aYnSN4qUz26nDhyLYgEXhpTPZKcCGSkn2y5JWksw7YPlxbUXirT3aqcCW6pX9b5KOHn081CHUqNK8HlxLMKgC1rm7oj3xrcNWBvSrNKVzDpQCz+A6lin16072tj4qY1yaLyxJcs96mHkClp8J8iu8eStxak9nuag3h3gGbYYShDq/nyValN67ONM/wLv9WjnYNHxA2tEW9cUGL3PTbw3cffux1ifKF/lUT7s3HfRfKXFVomfvxTGRq15Cwy97Z5FCk+UpOXD5wKMI3dey9LzfkUPkXFNnWMERsUi723IEs6yjJQYlhj1zJj2tQIcemDqFCtUtu3XIocMimdiCveUdW94+DAi02gAI77L8Qh7SXMlm1OgBexuWF3dWBPB5i/5xA2uN8ygfTAHTqLRK6gwInqv5eLD6T1eXM69po9/KCOQ8Fsooe32KZrJ6vYVEV9FYN8gL/xzokDeZS3oYVF7XXNRTYZBPHkNOsWId2CXPaorULKhwruQIqWfPbxJxhhey1oEKQTUQhp0Pvdauw0SeBB6gQ/TtFIKtCb3pD2PhFApUilJhMkiRkvdJUvg47tRsSqEONpJLDrGJhOhSeYGtMAt0i1Iirufhr9P6WY1CErc69loJY0/4VCozqd+0OBJ6XFGQMaV8ZYyY0uyKRR0yMqARZJmMGNCteCgvSxERPxeZosDNoNlhWECWP8Bk7hV4veRK4bGLigojakHWq/Sz2QlyQt1lZhqy47jvlB1pakIkRJK1rPhy/rpBI+/3ycgtJQZaBTq8kUqgBb5cc+QbkZPTeZ41IqD37u/EH5MRYAPrUyo4KMtGtQUqARaFPnYQerD/kH0sWDbgRZWlo07hfVpABLdDtX8OxtM5V63ZZQVCihbpPcMpkYehSpWUFAZ5poZsmHAozDl3KJPTT8qwJteEQ/03MnfamDQRhAJYDJKVJ0ytNT6mHemjGBhuDDwykQEzAHCH//9dUreLKLEy62tntPt8iRcoBeNbjd8bcHzJHUuZAaYAlXp7OMffWukbSlrhZYaS3Tsx92EOZFwQcD0usHnfN3OU3Q0oCRAuS+FYZz8wVRA8JvgMVQlNYNWPTNHdEWUr+l2MfKWEOsurmDo1X9Ed9V38RBu6+aDl0QNpjc8f4BCk90O+5uRurboSUKwd0axi81e0hadQHzV4abD70B0gKU9Dr1Eg7aFjAb3GEJD8Grb6ZaNDlQQh/FB6SohXo9MNEy3T09xLbWiMpuAONjgw0sTuIOGuXX3hIcbegTU14rMBXNq2zsij3N+5/KCjv9a92KCu69xPutUPzBaWhfydCcSDEcTM2XVBOhYehXLutrHUL7qVrJAxS0OGJ8HiaSSznUQKluY+HZTlocKweGOi2Dlm5VG6x25sR0Ubga6pGOFI6Gkf/mvHIWPihoRiq6UQoaZxDiSwqE2D7ohZz6qC0BHa0rl3c4wHbpVLwLI1Q1hpEq9BAiK6uFgXcoKysBftuArGWANcLtXCmj5LcAg5Jp7oPKl/V4rIBSuoBYSDMhzE5x2oB5gDlhA71g2dYFQPTW8VIeYhSghgIbawaA9cnxZD/AmW4HaAkmsvIK8Wxi66PFLpe05e9DTDVlQdhVjP8lyAB2kSomUxv1EeT2gN8kDvN4QGBMGXM41wyhsWc7cj3Dssm62EKNHEmf+YAzwdLe13Eo1oITGeMgUqeW61zFydHjBFXnqXWu5GPjKFjpgirCuD5zhgD58lxRx9Y6vbWON0JqxF4zuytSugJiQCW5mt7yytGQkKT5cLiOhFPWAzG8ejc3oKXVOeI1WeLK3fmGjsotXOLS5AWGhsPT22upZpi1S0w1I5sLgrL9DUeLmyubmuhtsbDO6vL9AqsCn61dye7CUJRGMfPHQCBK0UExSF1iAMnLjqlXbXdNOmO93+drtzYprF4p5z6ewUvMSJ8f+yOVU7nDV+13Xgo3A5Otrrey8+52wnQ9uSJp86U41HWz5OZzK4S1zO5Lwctv9dZ43y4uNVyS+vG/ZT0052GS/3Wh3Hv498jhw+GHfVCP+bWH96e7x/fu1/orP/fBvDpJAnoRCLIZDvohFTopG3oxIbo5J/oBLnIJNLoROvoZATphB3ppDZ9+T4ZXnO0FAPBdJLNdCLadLLmhELzdNL/5xwv74/VUZOgRUkD5qgcLckVGMULhhawgoNp1RSNm1ZgQynQKFGCJbwWaIyoOdiTrXpoRG+VgV1ZGaN2cZmBfWMlUSupxuDIbhGhJtFiBy5xNWd4MTZXHJwb1RIvIusReKJaThh2wibLCrwSbgqJfySLTQg+Gq2DGM8UB2tvDtSPwn4azAT+QsyCtO/nJ/Ed32/TYTBIZJyLiLFI5LFMBsEw3e45GPEFunDAl+k860IAAAAASUVORK5CYII='
              // color = "#3c71ff";
            } else if (eventType === 3) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#64b9b9";
            } else if (eventType === 4) {
              symbol =
                'image://data:image/png;base64,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'
              // color = "#019714";
            }
            const xAxis =
              (+dayjs(item.eventTime) -
                +dayjs(date).add(index, 'day').startOf('day')) /
              (60 * 60 * 24 * 1000)

            let xIndex = Math.floor(data.length * xAxis)
            //  相差太近进行偏移
            memIndex.push(xIndex)
            if (
              eventIndex !== 0 &&
              memIndex[eventIndex] - memIndex[eventIndex - 1] < 3
            ) {
              xIndex = Math.min(data.length - 1, xIndex + 2)
            }
            if (eventIndex === event.length - 1) {
              memIndex = []
            }

            return {
              coord: [
                +dayjs(date)
                  .add(index, 'day')
                  .startOf('day')
                  .add(intervalTime * xIndex, 'minute'),
                data[xIndex]
              ],
              symbol,
              itemStyle: {
                color
              }
            }
          })
        },
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ffaf00',
                width: 1
              },
              label: {
                show: isToB,
                formatter: `${i18n.t('unit.high')}`,
                distance: isMgDl ? [30, 0] : [27, 0]
              },
              yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ff0000',
                width: 1
              },
              label: {
                show: isToB,
                formatter: `${i18n.t('unit.low')}`,
                distance: isMgDl ? [30, 0] : [27, 0]
              },
              yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
            }
          ]
        }
      }
    ],
    visualMap: {
      show: false,
      pieces: [
        {
          gte: 0,
          lte: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#d4001a'
        },
        {
          gt: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          lte: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#59c4ea'
        },
        {
          gt: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#ffaf00'
        }
      ]
    }
  }
}

export function getMiniGluOptions(data = [], index, date, isMgDl = false, hyper = 10, hypo = 3.9) {
  const intervalTime = data.length === 1440 ? 1 : 5
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        show: false,
        splitLine: {
          show: false
        },
        min: +dayjs(date).add(index, 'day').startOf('day'),
        max: +dayjs(date)
          .add(index + 1, 'day')
          .startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        // show: false,
        type: 'value',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        position: 'right',
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        // name: "mmol/L",
        // nameLocation: "middle",
        // nameGap: 30,
        // nameTextStyle: {
        //   fontWight: "bold",
        // },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: i18n.tc('unit.mmolL'),
      right: -2,
      top: -11,
      show: false
    },
    grid: {
      x: 0,
      y: 10,
      x2: 0,
      y2: 10
    },
    animation: false,
    series: [
      {
        name: '血糖值',
        type: 'line',
        data: data.map((c, i) => [
          +dayjs(date)
            .add(index, 'day')
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ffaf00',
                width: 1
              },
              label: {
                show: false
              },
              yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: false, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: '#ff0000',
                width: 1
              },
              label: {
                show: false
              },
              yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
            }
          ]
        }
      }
    ],
    visualMap: {
      show: false,
      pieces: [
        {
          gte: 0,
          lte: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#d4001a'
        },
        {
          gt: isMgDl ? +(hypo * 18).toFixed(1) : +hypo,
          lte: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#59c4ea'
        },
        {
          gt: isMgDl ? +(hyper * 18).toFixed(1) : +hyper,
          color: process.env.VUE_APP_VERSION === 'x' ? '#506b9f' : '#ffaf00'
        }
      ]
    }
  }
}

export function getMultiGluChartOptions(data = [], beginDate, isMgDl = false, isToB = true) {
  const intervalTime = data.length > 0 ? (data[0].length === 1440 ? 1 : 5) : 5
  return {
    tooltip: {
      trigger: 'axis',
      show: false
    },
    legend: {
      show: !isToB,
      bottom: 0,
      left: isToB ? 0 : 50,
      icon: 'rect'
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        splitNumber: 4,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#DDD'
          }
        },
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5,
        position: isToB ? 'right' : 'left',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true
        },
        // name: isMgDl ? 'mg/dL' : 'mmol/L',
        // nameLocation: "middle",
        nameGap: 30,
        nameTextStyle: {
          fontWight: 'bold'
        },
        splitArea: {
          show: false
        }
      }
    ],
    title: {
      subtext: isMgDl ? i18n.tc('unit.mgdL') : i18n.tc('unit.mmolL'),
      right: isToB ? -2 : 'auto',
      left: isToB ? 'auto' : -4,
      top: -11
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 10,
      x2: isToB ? 80 : 20,
      y2: 95
    },
    animation: false,
    series: data.map((item, index) => {
      return {
        name: dayjs(beginDate).add(index, 'day').format('YYYY-MM-DD'),
        type: 'line',
        data: item.map((c, i) => [
          +dayjs()
            .startOf('day')
            .add(intervalTime * i, 'minute'),
          c || undefined
        ]),
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true
      }
    })
  }
}

export function getPentagonChartOptions(data = {}) {
  const mapping = {
    TOR: data.tor,
    MBG: data.mbg,
    'Intensity HYPER': data.intHyper,
    'Intensity HYPO': data.intHypo,
    CV: data.cv
  }
  return {
    radiusAxis: {
      show: false
    },
    grid: {
      x: 20,
      y: 20,
      x2: 20,
      y2: 20
    },
    radar: {
      axisNameGap: 5,
      axisName: {
        formatter: function (value, indicator) {
          if (mapping[value] || mapping[value] === 0) {
            let cookVal = value.split(' ')
            cookVal =
              cookVal.length === 2 ? `${cookVal[0]}\n${cookVal[1]}` : value
            const displayVal = Number.isInteger(mapping[value])
              ? mapping[value]
              : mapping[value].toFixed(1)
            return `${cookVal}(${displayVal})`
          } else {
            return value
          }
        }
      },
      axisLine: {
        lineStyle: {
          color: '#000'
        }
      },
      axisTick: {
        show: false,
        length: 3
      },
      axisLabel: {
        showMaxLabel: false,
        showMinLabel: false
      },
      splitNumber: 76,
      z: 10,
      shape: 'polygon',
      center: ['50%', '50%'],
      radius: '80%',
      scale: false,
      indicator: [
        {
          name: 'TOR',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 40) {
                return 1300
              } else if (value === 50) {
                return 1600
              } else if (value === 30) {
                return 1000
              }
            }
          }
        },
        {
          name: 'MBG',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 90
              } else if (value === 30) {
                return 220
              } else if (value === 60) {
                return 290
              } else if (value === 44) {
                return 260
              }
            }
          },
          axisTick: {
            // show: false
          }
        },
        {
          name: 'Intensity HYPER',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 31) {
                return 60000
              } else if (value === 42) {
                return 80000
              } else if (value === 60) {
                return 110000
              }
            }
          }
        },
        {
          name: 'Intensity HYPO',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 14) {
                return 0
              } else if (value === 28) {
                return 4800
              } else if (value === 36) {
                return 5500
              } else if (value === 52) {
                return 6400
              }
            }
          }
        },
        {
          name: 'CV',
          max: 76,
          axisLabel: {
            show: true,
            formatter: function (value) {
              if (value === 17) {
                return 14
              } else if (value === 30) {
                return 25
              } else if (value === 45) {
                return 40
              } else if (value === 66) {
                return 60
              }
            }
          }
        }
      ],
      splitArea: {
        show: false
      },
      splitLine: {
        show: false
        // lineStyle: {
        //   color: ["#fff", "#fff", "#fff", "#fff", "#fff", "#000"],
        // },
      }
    },
    polar: {},
    angleAxis: {
      show: false
    },
    animation: false,
    series: [
      {
        name: 'name_1',
        type: 'radar',
        z: 10,
        // colorBy: 'data',
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: '#000'
        },
        data: [
          {
            value: [76, 76, 76, 76, 76]
          }
        ]
      },
      {
        name: 'name_2',
        type: 'radar',
        z: 9,
        areaStyle: {
          opacity: 1,
          color: '#ced686'
        },
        symbol: 'none',
        lineStyle: {
          width: 3,
          color: '#a1101c'
        },
        data: [
          {
            value: [14, 14, 14, 14, 14, 14]
          }
        ]
      },
      {
        name: 'name_3',
        type: 'radar',
        z: 1,
        areaStyle: {
          opacity: 1,
          color: '#b02429'
        },
        symbol: 'none',
        lineStyle: {
          width: 1
        },
        data: [
          {
            value: [
              data.tor_mm,
              data.mbg_mm,
              data.intHyper_mm,
              data.intHypo_mm,
              data.cv_mm
            ]
          }
        ]
      }
    ]
  }
}

export function getDayPentagonChartOptions(data = {}) {
  return {
    radiusAxis: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    radar: {
      axisNameGap: 5,
      axisName: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'grey'
        }
      },
      axisTick: {
        show: false,
        length: 3
      },
      axisLabel: {
        showMaxLabel: false,
        showMinLabel: false
      },
      splitNumber: 76,
      z: 10,
      shape: 'polygon',
      center: ['50%', '50%'],
      radius: '80%',
      scale: false,
      indicator: [
        {
          name: 'TOR',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'MBG',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'Intensity HYPER',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'Intensity HYPO',
          max: 76,
          axisLabel: {
            show: false
          }
        },
        {
          name: 'CV',
          max: 76,
          axisLabel: {
            show: false
          }
        }
      ],
      splitArea: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    polar: {},
    angleAxis: {
      show: false
    },
    animation: false,
    series: [
      {
        name: 'name_1',
        type: 'radar',
        z: 10,
        // colorBy: 'data',
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: 'grey'
        },
        data: [
          {
            value: [76, 76, 76, 76, 76]
          }
        ]
      },
      {
        name: 'name_2',
        type: 'radar',
        z: 9,
        areaStyle: {
          opacity: 1,
          color: '#ced686'
        },
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: '#000'
        },
        data: [
          {
            value: [14, 14, 14, 14, 14]
          }
        ]
      },
      {
        name: 'name_3',
        type: 'radar',
        z: 1,
        areaStyle: {
          opacity: 0.6,
          color: '#a1101c'
        },
        symbol: 'none',
        lineStyle: {
          width: 0
        },
        data: [
          {
            value: [
              data.tor_mm,
              data.mbg_mm,
              data.intHyper_mm,
              data.intHypo_mm,
              data.cv_mm
            ]
          }
        ]
      }
    ]
  }
}

export function getAreaChartOptions(data = [], beginDate, dayNum) {
  return {
    tooltip: {
      show: false
    },
    title: {
      subtext: 'mm²',
      left: 25,
      top: 0
    },
    legend: {
      show: false
    },
    grid: {
      left: '4%',
      top: 40,
      right: 0,
      // right: "4%",
      bottom: '8%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: new Array(dayNum)
        .fill(0)
        .map((c, i) => i)
        .map((time) =>
          dayjs(beginDate).startOf('day').add(time, 'day').format('MM.DD')
        )
    },
    yAxis: {
      type: 'value'
    },
    animation: false,
    series: [
      {
        name: 'standard',
        type: 'bar',
        stack: 'total',
        color: '#ced686',
        label: {
          show: false
        },
        data: new Array(dayNum).fill(466)
      },
      {
        name: 'area',
        type: 'bar',
        stack: 'total',
        color: '#a1101c',
        label: {
          show: false
        },
        data: data
          .map((c) => c.area)
          .slice(0, dayNum)
          .map((val) => (val <= 466 ? 466 : +val - 466))
      }
    ]
  }
}
